/*
 *
 * LanguageProvider constants
 *
 */
export var CHANGE_LOCALE = 'app/LanguageToggle/CHANGE_LOCALE';
